module.controller('listBankCtrl', ['$scope', '$state', '$http', 'baseURI', 'OVERLAY', '$stateParams',
  function ($scope, $state, $http, baseURI, OVERLAY, $stateParams){
    $scope.overlay = OVERLAY['member.home.bank/manage'];

    $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
      $scope.banks = resp.data.Data || [];
    });

    // Creates an array of Active categories (true, false)
    $scope.groupBanks = function(){
      var groupBanks = [];

      angular.forEach($scope.banks, function (bank, key){
        if(groupBanks.indexOf(bank.Active) == -1){
          groupBanks.push(bank.Active);
        }
      });

      return groupBanks.sort();
    };

  }]);
